// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
